import React, { useEffect, useRef } from 'react';
import './Footer.css';

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('footer-reveal-active');
          } else {
            // Agar aap chahte hain ki scroll up karne par animation reset ho
            entry.target.classList.remove('footer-reveal-active');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = footerRef.current.querySelectorAll('.footer-animate');
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <footer className="premium-footer-root" ref={footerRef}>
      <div className="footer-glow-effect"></div>
      
      <div className="footer-main-container">
        {/* Top Section: Branding & Mission */}
        <div className="footer-top-row footer-animate">
          <div className="footer-brand-info">
            <h2 className="footer-logo-text">The Doctor <span>At Home</span></h2>
            <p className="footer-tagline">Your Trusted Home Healthcare Partner</p>
          </div>
          
          <div className="footer-founder-box">
             <span className="founder-label">Founder</span>
             <p className="founder-name">Dr. Hridaynath Mangesh Lad</p>
          </div>
        </div>

        <div className="footer-divider footer-animate"></div>

        {/* Middle Section: Quick Links & Legal */}
        <div className="footer-mid-row footer-animate">
          <div className="footer-legal-links">
            <a href="/privacy-policy" className="legal-link">Privacy Policy</a>
            <span className="link-sep">|</span>
            <a href="/terms-of-service" className="legal-link">Terms of Service</a>
          </div>
          
          <div className="footer-contact-fast">
             <a href="mailto:thedoctorathome2@gmail.com">thedoctorathome2@gmail.com</a>
             <a href="tel:+916354355617">+91 635 435 5617</a>
          </div>
        </div>

        {/* Bottom Section: Copyright */}
        <div className="footer-bottom-row footer-animate">
          <p>© 2026 The Doctor At Home. All rights reserved.</p>
          <div className="footer-social-deco">
             <div className="deco-dot"></div>
             <div className="deco-dot"></div>
             <div className="deco-dot"></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;